import { AfterViewInit, Directive, Input, SkipSelf } from "@angular/core";
import { ReduxRequestsMap } from "../../../redux/redux-requests-map.service";
import { CommonFieldManagerDirective } from "../field-manager.directive";

@Directive({
    selector: "[common-field-actions]",
    exportAs: "CommonFieldActions",
})
export class ChoiceFieldActionsDirective implements AfterViewInit {

    @Input("fieldOptionsCategory") public set fieldOptionsCategoryInput(value: string) {
        this.fieldOptionsCategory = value;
        this.getList();
    }

    public fieldOptionsCategory: string;

    constructor(
        public reduxRequests: ReduxRequestsMap,
        @SkipSelf() public fieldManager: CommonFieldManagerDirective,
    ) { }

    public get stateProp() {
        return this.fieldManager.context.stateProp;
    }

    public ngAfterViewInit() {
        this.getList();
    }

    public getList(searchText?: string, hardRefresh = true) {
        this.fieldManager.isAfterViewInit$.subscribe(() => {
            if (!!this.fieldManager.fieldOptions && !hardRefresh) {
                this.fieldManager.dispatchListLoad(this.fieldManager.fieldOptions);
            } else {
                const category = this.fieldOptionsCategory;
                (this.reduxRequests.within(this.stateProp) as any).getList({ searchText, category })
                    .map((body) => body.data)
                    .subscribe((payload) => {
                        this.fieldManager.dispatchListLoad(payload);
                    });
            }
        });
    }
}
